import React from 'react'

import './link-externo.scss'
import _ from 'lodash'

const getUrl = (props) => {
  const url = _.get(props, 'location.state.url', '')
  if (url) {
    const newUrl = url.replace('/geral/linkExterno/', '')
    if (newUrl.endsWith('/')) {
      return newUrl.substring(0, newUrl.length - 1)
    }
    return newUrl
  }
  return url
}

const getParametros = (props) =>
  [
    `hash_empresa=${props.currentCompany.hashEmpresa}`,
    `oid_empresa=${props.currentCompany.oid}`,
    `oid_usuario=${props.oidCurrentUser}`,
    `oid_unidade=${props.oidsUnits}`,
  ].join('&')

// a url vem do cadastro do link, entao pode ja ter query string e/ou fragmento
const getUrlComParametros = (props) => {
  const url = getUrl(props)
  if (!url) {
    return url
  }
  const indiceFragmento = url.indexOf('#')
  const base = indiceFragmento >= 0 ? url.substring(0, indiceFragmento) : url
  const fragmento = indiceFragmento >= 0 ? url.substring(indiceFragmento) : ''
  const separador = base.includes('?') ? '&' : '?'
  return base + separador + getParametros(props) + fragmento
}

export const LinkExternoForm = (props) => {
  return (
    <div className="container">
      <iframe className="responsive-iframe" src={getUrlComParametros(props)}></iframe>
    </div>
  )
}
